import * as Immutable from "immutable";
import { AbstractImmutableValueMessage } from "./abstractImmutableValueMessage";
import { DisallowedInfo } from "../..";

export class DisallowedValueMessage extends AbstractImmutableValueMessage {

  protected readonly DISALLOWED_INFOS = "disallowedInfos";

  get disallowedInfos(): Immutable.List<DisallowedInfo> { return this.getInternalValue<Immutable.List<DisallowedInfo>>(this.DISALLOWED_INFOS); }
  setDisallowedInfos(disallowedInfos: Immutable.List<DisallowedInfo>): this { return this.setInternalValue(this.DISALLOWED_INFOS, disallowedInfos);}
}